import '../../vendor/daterangepicker/daterangepicker'
import moment from 'moment'

export const DatePicker = daterangeClass => {

  /** Получили все поля с датой */
  const pickersArr = document.querySelectorAll(`.${daterangeClass}`)

  /** Создаём настройки для пикеров типа range и single */
  const config = {
    'single': {
      autoUpdateInput: false,
      locale: {
        cancelLabel: 'Clear'
      },
      singleDatePicker: true,
      minYear: 1901,
      maxYear: parseInt(moment().format('YYYY'),5)
    },
    'range': {
      autoUpdateInput: false,
      locale: {
        cancelLabel: 'Clear'
      }
    }
  }
  /** Если на странице присутствуют пикеры, бежим по коллекции и создаём экземпляры.
   * На вход отдаём элемент, настройки и тип календаря */
  pickersArr?.forEach(item => createDate(item, config[item.dataset.picker], item.dataset.picker))
}


/** Вызываем функцию-конструктор, на вход отдаём элемент-календарь, настройки и его тип */
function createDate(calendar, configObj, type) {

  /** Вызываем плагин создания календаря, на вход отдаём объект с настройками */
  $(calendar).daterangepicker(configObj)

  $(calendar).on('apply.daterangepicker', function(ev, picker) {
    $(this).val(type === 'range'
      ? picker.startDate.format('DD.MM.YY') + ' - ' + picker.endDate.format('DD.MM.YY')
      : picker.startDate.format('DD.MM.YY'))
    addClass(this)
  })

  $(calendar).on('cancel.daterangepicker', function(ev, picker) {
    $(this).val('');
    removeClass(this)
  })

  $(calendar).on('change', function(params) {
    if ($(this).val('')) {
      removeClass(this)
    }
    return false
  })
}

function addClass(calendar) {
  calendar.classList.add('datepicker--active')
}

function removeClass(calendar) {
  calendar.classList.remove('datepicker--active')
}